import { render, staticRenderFns } from "./video.vue?vue&type=template&id=36773be2&scoped=true&"
import script from "./video.vue?vue&type=script&lang=ts&"
export * from "./video.vue?vue&type=script&lang=ts&"
import style0 from "./video.vue?vue&type=style&index=0&id=36773be2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36773be2",
  null
  
)

export default component.exports